import React, { useContext, useEffect, useState } from 'react';
import { PermissionContext } from './PermissionContext';
import { mockRoles } from '../../utils/mockData'; // Import mockRoles for role names

const PermissionGrid = ({ roleId }) => {
  const { permissions, updatePermissions } = useContext(PermissionContext);
  const [currentPermissions, setCurrentPermissions] = useState([]);

  // Fetch the permissions for the selected role when roleId changes
  useEffect(() => {
    const rolePermissions = permissions.find((perm) => perm.roleId === roleId);
    setCurrentPermissions(rolePermissions ? rolePermissions.permissions : []);
  }, [roleId, permissions]);

  const togglePermission = (perm) => {
    setCurrentPermissions((prev) =>
      prev.includes(perm)
        ? prev.filter((p) => p !== perm)
        : [...prev, perm]
    );
  };

  const handleSave = () => {
    updatePermissions(roleId, currentPermissions);
    alert('Permissions updated successfully!');
  };

  // Find the role name based on the roleId
  const roleName = mockRoles.find((role) => role.id === roleId)?.name || 'Unknown Role';

  return (
    <div>
      <h5 className="mt-3">Manage Permissions for: <span className="text-primary">{roleName}</span></h5>
      <div className="border rounded p-3 mt-3">
        {['Read', 'Write', 'Delete'].map((perm) => (
          <div key={perm} className="form-check">
            <input
              type="checkbox"
              id={`${roleId}-${perm}`}
              className="form-check-input"
              checked={currentPermissions.includes(perm)}
              onChange={() => togglePermission(perm)}
            />
            <label htmlFor={`${roleId}-${perm}`} className="form-check-label ms-2">
              {perm}
            </label>
          </div>
        ))}
      </div>
      <button className="btn btn-primary mt-3" onClick={handleSave}>
        Save Permissions
      </button>
    </div>
  );
};

export default PermissionGrid;
